export const generateSubstrateModel = () => ({
  name: '',
  thickness: null,
  abbreviation: '',
});
